import { render, staticRenderFns } from "./obServerCharts.vue?vue&type=template&id=685c264a&scoped=true&"
import script from "./obServerCharts.vue?vue&type=script&lang=js&"
export * from "./obServerCharts.vue?vue&type=script&lang=js&"
import style0 from "./obServerCharts.vue?vue&type=style&index=0&id=685c264a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685c264a",
  null
  
)

export default component.exports